/*
 * OP source tracking (27 Oct 2026).
 * Remembers where a visitor came from for 30 days (not only this visit), so COD-form
 * orders keep their ad tag even when the customer comes back later to order.
 *  - A new ad click (utm / gclid / gbraid / wbraid / fbclid / ttclid) replaces the stored one.
 *  - A plain visit (Google search, Instagram, other site) is stored as utm_source / organic or referral,
 *    but never overwrites a paid click from the last 30 days.
 *  - Google iPhone clicks (gbraid / wbraid) are labelled google / cpc.
 * Hands the result to op-cod.js through sessionStorage 'opx_attr' (the key op-cod.js already reads).
 * Loaded from snippets/op-head.liquid, before op-cod.js. Never blocks anything.
 */
(function () {
  'use strict';
  if (window.__opAttribution) return;
  window.__opAttribution = true;

  var KEY = 'opx_attr';
  var DAYS = 30;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
                'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid'];

  function readLocal() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (v && v.at && Date.now() - v.at < DAYS * 864e5) return v;
    } catch (e) {}
    return null;
  }
  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
    try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }
  function isPaid(v) {
    return !!(v && (v.gclid || v.gbraid || v.wbraid || v.fbclid || v.ttclid ||
      /^(paid|cpc|ppc|paidsocial|paid_social)$/i.test(v.utm_medium || '') ||
      /_ads$|ads$/i.test(v.utm_source || '')));
  }

  try {
    var p = new URLSearchParams(location.search);
    var found = {};
    var any = false;
    PARAMS.forEach(function (k) {
      var val = p.get(k);
      if (val) { found[k] = val.slice(0, 200); any = true; }
    });
    if (any && !found.utm_source) {
      if (found.gclid || found.gbraid || found.wbraid) { found.utm_source = 'google'; found.utm_medium = found.utm_medium || 'cpc'; }
      else if (found.ttclid) { found.utm_source = 'tiktok'; found.utm_medium = found.utm_medium || 'paid'; }
    }

    var fromReferrer = false;
    if (!any) {
      var host = '';
      try { host = new URL(document.referrer).hostname.replace(/^www\./, ''); } catch (e) {}
      var own = location.hostname.replace(/^www\./, '');
      if (host && host.indexOf(own) === -1 && !/shopify|paypal|stripe|payfast|jazzcash|easypaisa/.test(host)) {
        var src = /(^|\.)google\./.test(host) ? 'google'
          : /instagram/.test(host) ? 'instagram'
          : /facebook|fb\.com|fb\.me|messenger/.test(host) ? 'facebook'
          : /tiktok/.test(host) ? 'tiktok'
          : /youtube|youtu\.be/.test(host) ? 'youtube'
          : /bing|yahoo|duckduckgo/.test(host) ? host.split('.')[0]
          : host;
        found = {utm_source: src, utm_medium: /^(google|bing|yahoo|duckduckgo)$/.test(src) ? 'organic' : 'referral', referrer: host};
        any = true;
        fromReferrer = true;
      }
    }

    var stored = readLocal();
    if (any) {
      if (fromReferrer && isPaid(stored)) {
        save(stored); // keep the paid click from the last 30 days
      } else {
        found.landing = location.origin + location.pathname;
        found.at = Date.now();
        save(found);
      }
    } else if (stored) {
      // direct visit: bring the remembered source back into this visit
      var cur = readSession();
      if (!cur || (cur.at || 0) < stored.at) {
        try { sessionStorage.setItem(KEY, JSON.stringify(stored)); } catch (e) {}
      }
    }
  } catch (err) {}
})();
